import { LazyLoadComponent } from '@src/components';
import { lazy } from 'react';

const PackageListPage = lazy(() =>
  import('@src/pages/Dashboard').then((module) => ({
    default: module.Packages,
  }))
);

export function PackageContainer() {
  return <LazyLoadComponent Component={<PackageListPage />} />;
}
